import {
  ButtonSignin,
  ButtonSubmitted,
  ContainerPage,
  ContainerStyled,
  FormContainer,
} from "./styles";

import useAuth from "../../../hooks/useAuth";
import Header from "../../../components/Header";
import { Contact } from "../../../pages/Contact";
import { useNavigate } from "react-router-dom";
import { WhatsApp } from "../../../components/WhatsApp";
import { useState } from "react";
import { Footer } from "../../../components/Footer";
import { sendNotificationEmailRegistration } from "../../../services/resources/EmailRegistration";

export const Signup = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const { onRegister, onLogin } = useAuth();
  const navigate = useNavigate();

  const handleSignin = () => {
    navigate("/signin");
  };

  const handleRegister = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const data = {
      name,
      email,
      password,
    };

    await onRegister(data);

    if (name.trim() === "") {
      setErrorMessage("Nome inválido");
      return;
    }

    if (!email.match(/^\S+@\S+\.\S+$/) || email.length < 6) {
      setErrorMessage("E-mail inválido");
      return;
    }

    if (password.length < 6) {
      setErrorMessage(
        "Por favor, insira uma senha com mais de seis caracteres."
      );
      return;
    }

    const hasLetterAndNumber = /^(?=.*[a-zA-Z])(?=.*[0-9])/.test(password);
    if (!hasLetterAndNumber) {
      setErrorMessage("A senha deve conter pelo menos uma letra e um número");
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage("Senhas diferentes");
      return;
    }

    const dataLogin = {
      email,
      password,
    };

    const responseLogin = await onLogin(dataLogin);

    if (!responseLogin?.id) {
      setErrorMessage("E-mail já cadastrado anteriormente.");
      return;
    }

    const emailRegistration = {
      email,
    };

    sendNotificationEmailRegistration(emailRegistration);

    navigate("/");
  };

  return (
    <ContainerPage>
      <ContainerStyled>
        <Header />
        <FormContainer>
          <form onSubmit={handleRegister}>
            <h2>CADASTRO</h2>
            <div className="login-form">
              <h3>NOME</h3>
              <input
                type="text"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </div>
            <div className="login-form">
              <h3>EMAIL</h3>
              <input
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>
            <div className="login-form">
              <h3>SENHA</h3>
              <input
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </div>
            <div className="login-form">
              <h3>CONFIRME A SENHA</h3>
              <input
                type="password"
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
              />
            </div>
            {errorMessage && <p>{errorMessage}</p>}
            <div>
              <div>
                <ButtonSubmitted type="submit">CRIAR USUÁRIO</ButtonSubmitted>
                <ButtonSignin type="button" onClick={handleSignin}>
                  JÁ POSSUÍ UMA CONTA?
                </ButtonSignin>
              </div>
            </div>
          </form>
        </FormContainer>
        <WhatsApp />
      </ContainerStyled>
      <Contact />
      <Footer />
    </ContainerPage>
  );
};
